import Tippy from "@tippyjs/react";
// import "tippy.js/dist/tippy.css";

function Tooltip({
  children,
  content,
  placement = "top",
  disabled = false,
  className = ""
}) {
  if ((!content || disabled) && !invoiceMessageIds) {
    return children;
  }

  const jsxContent = (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: content }}
    ></div>
  );

  return (
    <Tippy content={jsxContent} placement={placement}>
      {children}
    </Tippy>
  );
}

export default Tooltip;
